import React, { useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Table,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import Pagi2 from "common/utils/Pagi2";
import { CommonTableContainer } from "common/utils/ComonTableContainer";
import moment from "moment";
import { json } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import configure from "configure";
import Swal from "sweetalert2";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import userImg from "../../assets/images/users/AdminImg.png";

const Addfollowups = ({ id }) => {
  const [Data, setData] = useState([]);
  const [Loading, setloading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [description, setDescription] = useState("");
  const [callTime, setCallTime] = useState("");

  useEffect(() => {
    fetchNotes();
  }, []);

  const openModal = (item = null) => {
    setEditingData(item);
    setDescription(item?.description || "");
    const rawCallTime = item?.date_time;
    const formattedCallTime = rawCallTime
      ? moment(rawCallTime).format("YYYY-MM-DDTHH:mm")
      : "";

    setCallTime(formattedCallTime);
    setShowModal(true);
  };

  const handleSave = async () => {
    const token = secureLocalStorage.getItem("Token");

    const payload = {
      lead_id: id,
      description,
      date_time: callTime,
    };

    try {
      setloading(true);

      try {
        const url = editingData?.id
          ? `${configure.apiUrl}/leads/follow-up/${editingData?.id}`
          : `${configure.apiUrl}/leads/follow-up/add`;

        const method = editingData?.id ? "put" : "post";

        await axios[method](url, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        Swal.fire(
          "Success",
          editingData?.id ? "Lead updated!" : "Lead added!",
          "success"
        );
        setShowModal(false);
        fetchNotes();
      } catch (err) {
        console.log(err);
        Swal.fire("Error", "Something went wrong", "error");
      }
    } finally {
      setloading(false);
    }
  };

  const fetchNotes = async () => {
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios.post(
        `${configure.apiUrl}/leads/follow-up`,
        {
          lead_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res?.data?.success) {
        setloading(false);
        setData(res?.data?.followUp?.reverse());
      }
    } catch (e) {
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const ondelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Follow Up!",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No, cancel",
      confirmButtonText: "Yes, delete it!",
      dangerMode: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setloading(true);
        const token = secureLocalStorage.getItem("Token");
        try {
          const response = await axios({
            method: "delete",
            url: `${configure.apiUrl}/leads/follow-up/${id}`,
            headers: {
              Authorization: `Bearer ${token}`
            },
          });

          // Show success alert
          await Swal.fire({
            icon: "success",
            text: "Note Deleted Successfully",
          });

          // Update state with new data
          fetchNotes()
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "Lead Delete Cancelled",
          });
        } finally {
          setloading(false);
        }
      }
    });
  };

  return (
    <React.Fragment>
      <div>
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className=" text-dark">Follow Up</h4>
                      <button
                        //  to={`${configure.appUrl}/add-lead`}
                        onClick={() => openModal()}
                        className=" btn ms-md-2 btn-save  btn-label me-2"
                      >
                        <i className="fas fa-plus me-1 label-icon"></i> Follow
                        Up
                      </button>
                    </div>
                  </CardTitle>

                  <div>
                    {Data?.length != 0 ? (
                      <ul className="verti-timeline list-unstyled notes-box">
                        {Data.map((item, index) => (
                          <li
                            key={index}
                            className="event-list position-relative"
                          >
                            <div className="event-timeline-dot">
                              <img
                                src={
                                  item?.userDetails?.name
                                    ? `${configure.marsimg}/${item?.userDetails?.avatar}`
                                    : userImg
                                }
                                className="userImg me-3"
                                alt="User"
                              />
                            </div>
                            <div className="d-flex">
                              <div className="note flex-grow-1 ms-4 py-2 rounded ps-4">
                                <div className="d-flex justify-content-between">
                                  <div>
                                    <p className="text-muted mb-4">
                                      <h6 className="d-inline me-2">
                                        By {item?.userDetails?.name}
                                      </h6>
                                      {moment(item?.created_at).format(
                                        "YYYY-MM-DD HH:MM:SS"
                                      )}{" "}
                                      <span className="pl-15">
                                        Got in touch with this Customer at{" "}
                                        {moment(item?.date_time)?.isValid() ? moment(item?.date_time).format("YYYY-MM-DD HH:MM:SS") : 'No Time Selected'}
                                      </span>
                                    </p>
                                    <i className="bi bi-triangle-fill note-icon"></i>
                                  </div>
                                  <div>
                                    <button
                                      onClick={() => openModal(item)}
                                      className="btn btn-sm btn-outline-secondary me-1"
                                      title="View"
                                    >
                                      <i className="fas fa-pen"></i>
                                    </button>
                                    <button
                                      onClick={() => ondelete(item?.id)}
                                      className="btn btn-sm btn-outline-danger me-1"
                                      title="View"
                                    >
                                      <i className="fas fa-trash-alt"></i>
                                    </button>
                                  </div>
                                </div>
                                <div
                                  className="Features"
                                  dangerouslySetInnerHTML={{
                                    __html: item?.description,
                                  }}
                                />
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : null}
                    {Data?.length == 0 ? (
                      <p>No Follow ups has been Added Yet</p>
                    ) : null}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        isOpen={showModal}
        size="xl"
        toggle={() => setShowModal(!showModal)}
      >
        <ModalHeader toggle={() => setShowModal(!showModal)}>
          {editingData ? "Edit Follow-Up" : "Add Follow-Up"}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <label>Description</label>
            <CKEditor
              editor={ClassicEditor}
              data={description}
              onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setDescription(data);
              }}
            />
          </div>
          <div className="mb-3">
            <label>Call Time</label>
            <input
              type="datetime-local"
              className="form-control"
              value={callTime}
              onChange={(e) => setCallTime(e.target.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="btn btn-save" color="primary" onClick={handleSave}>
            {editingData ? "Update" : "Add"}
          </Button>
          <Button color="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default Addfollowups;
